type State = {
  focused: boolean;
};

type Action = { type: 'SEARCH_FOCUS' | 'SEARCH_BLUR' };

const initialState: State = {
  focused: false,
};

export default function reducer(state = initialState, action: Action): State {
  if (!state) {
    return {
      ...initialState,
    };
  }

  switch (action.type) {
    case 'SEARCH_FOCUS': {
      return {
        ...state,
        focused: true,
      };
    }

    case 'SEARCH_BLUR': {
      return {
        ...state,
        focused: false,
      };
    }
    default:
  }

  return state;
}
